/**
 * @class
 */
import Base from './assetConstituent';

export default class AssetConstituent_Page extends Base {
	/**
	 * @property {object}  defaults             - The default attribute values
	 * @property {number}  defaults.type        - Default type (3 = page)
	 * @property {number}  defaults.pageNumber  - The default page number (client side)
	 */
	get defaults() {
		return _.extend(super.defaults, {
			type: 3,
			// Client attributes
			pageNumber: 0,
		});
	}
	/** @type {array} */
	get clientAttrs() {
		return ['pageNumber'];
	}

	/**
	 * @override
	 * @param {object} attr Model attributes
	 * @param {object} opts Model options
	 */
	constructor(attrs, opts) {
		super(attrs, opts);

		// Internationalize the title for pages
		var title = this.get('title');
		if (title) {
			// "Page n"
			title = title.split(' ');
			if (title.length > 1) {
				this.attributes.title = i18n.t('i18n.pageAndNumber', {
					page: title[1],
				});
			}
		}
	}

	/** @type {string} */
	static get __name__() {
		return 'AssetConstituent_Page';
	}
}
